import { FC, ReactNode } from 'react';
import { Access, Scope } from '../types';
import { useUserContext } from './useUserContext';

type WithAccessGrantedProps = {
  requiredScopeType?: Scope;
  children: ReactNode;
};

/**
 * Render children if access is granted.
 * Required access type can be specified with prop.
 */
export const WithAccessGranted: FC<WithAccessGrantedProps> = ({ children, requiredScopeType: requiredAccessType }) => {
  const { access, scope } = useUserContext();
  const hasMinimumRequiredAccess = !requiredAccessType || scope === requiredAccessType;
  const isAccessGranted = access === Access.pass && hasMinimumRequiredAccess;
  return isAccessGranted ? <>{children}</> : null;
};

/**
 * Render children if access is granted with full access.
 */
export const WithFullAccessGranted: FC<{ children: ReactNode }> = ({ children }) => (
  <WithAccessGranted requiredScopeType={Scope.full}>{children}</WithAccessGranted>
);
